import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember, TypedJSON} from 'typedjson';
import {FrequencyPlanChannelType} from '@/model/lora/FrequencyPlanChannelType';

@jsonObject({
  typeResolver: FrequencyPlanChannel.TypeResolver,
})
export abstract class FrequencyPlanChannel {

  public static TypeResolver(channel: any, knownTypes: Map<string, Function>) {
    switch (channel.type) {
      case FrequencyPlanChannelType.Multi:
        return knownTypes.get('MultiSfFrequencyPlanChannel');

      case FrequencyPlanChannelType.Std:
        return knownTypes.get('StdFrequencyPlanChannel');

      case FrequencyPlanChannelType.Fsk:
        return knownTypes.get('FskFrequencyPlanChannel');
    }
  }

  @jsonMember({name: 'label'})
  public Label!: string;

  @jsonMember({name: 'enabled'})
  public Enabled!: boolean;

  @jsonMember({name: 'radio'})
  public Radio!: number;

  @jsonMember({name: 'frequency'})
  public Frequency!: number;

  @jsonMember({name: 'type', constructor: String})
  public Type!: FrequencyPlanChannelType;
}

@jsonObject
export class MultiSfFrequencyPlanChannel extends FrequencyPlanChannel {

}

@jsonObject
export class StdFrequencyPlanChannel extends FrequencyPlanChannel {

  @jsonMember({name: 'bandwidth'})
  public Bandwidth!: number;

  @jsonMember({name: 'spreadfactor'})
  public SpreadFactor!: number;
}

@jsonObject
export class FskFrequencyPlanChannel extends FrequencyPlanChannel {

  @jsonMember({name: 'bandwidth'})
  public Bandwidth!: number;

  @jsonMember({name: 'datarate'})
  public Datarate!: number;
}
